import { Card, CardContent } from "../../../card";

interface TimelineEvent {
  date: string;
  title: string;
  description?: string;
  status?: 'completed' | 'current' | 'upcoming';
}

interface TimelineProps {
  data: {
    title?: string;
    events: TimelineEvent[];
  };
}

export const Timeline = ({ data }: TimelineProps) => {
  if (!data?.events || !Array.isArray(data.events)) return null;

  return (
    <Card className="my-8">
      <CardContent className="p-6">
        {data.title && (
          <h3 className="text-lg font-semibold text-neutral-900 mb-6">{data.title}</h3>
        )}

        <div className="relative pl-2">
          {/* Vertical Line with gradient */}
          <div className="absolute top-2 bottom-2 left-[19px] w-[2px] bg-gradient-to-b from-orange-400 via-orange-300 to-neutral-200" />

          <div className="space-y-8">
            {data.events.map((event, idx) => (
              <div key={idx} className="relative flex gap-6 group">
                {/* Dot */}
                <div className={`
                  flex-shrink-0 w-10 h-10 rounded-full border-4 z-10 flex items-center justify-center bg-white transition-all duration-200
                  ${event.status === 'completed' ? 'border-orange-100 text-orange-600 shadow-[0_0_0_4px_rgba(255,107,53,0.1)]' :
                    event.status === 'current' ? 'border-orange-200 text-orange-600 ring-2 ring-orange-100 shadow-[0_0_0_4px_rgba(255,107,53,0.15)]' :
                    'border-neutral-100 text-neutral-400'}
                `}>
                  <div className={`w-3 h-3 rounded-full transition-all ${
                    event.status === 'completed' ? 'bg-gradient-to-br from-orange-400 to-orange-600' :
                    event.status === 'current' ? 'bg-gradient-to-br from-orange-500 to-orange-600 animate-pulse' :
                    'bg-neutral-300'
                  }`} />
                </div>

                <div className="flex-1 pt-1">
                  <div className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-1 mb-1">
                    <h4 className={`font-semibold text-base ${
                      event.status === 'current' ? 'text-orange-700' :
                      event.status === 'completed' ? 'text-neutral-900' :
                      'text-neutral-600'
                    }`}>
                      {event.title}
                    </h4>
                    <span className={`text-xs font-mono px-2 py-0.5 rounded-md self-start sm:self-auto ${
                      event.status === 'completed' || event.status === 'current'
                        ? 'text-orange-600 bg-orange-50'
                        : 'text-neutral-500 bg-neutral-100'
                    }`}>
                      {event.date}
                    </span>
                  </div>
                  {event.description && (
                    <p className="text-sm text-neutral-600 leading-relaxed max-w-2xl">
                      {event.description}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};




